import { PluginDetailsItem } from "./PluginDetailsItem";

export default PluginDetailsItem;
